module.exports = __webpack_public_path__ + "static/media/invalid-drive.1c8c7fa9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/invalid-drive.svg
// module id = 635
// module chunks = 0